import React from 'react';

import { formatPhoneNumber } from 'common/formatters';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrCard from 'client/components/SrCard/SrCard';
import SrLink from 'client/components/SrLink/SrLink';

const UPAccountManagerCard = ({
  name,
  position,
  email,
  phone,
  profilePictureUrl,
  linkText,
  linkUrl,
}) => {
  return (
    <SrCard margin="0" maxWidth="375px" height="355px" padding="27px 20px">
      <SrBox display="flex" flexDirection="column" alignItems="center">
        <SrText font="greycliff" fontSize="24px" weight="800" display="block" align="center">
          Your Account Manager
        </SrText>
        <SrBox
          borderRadius="50%"
          width="100px"
          height="100px"
          backgroundImage={`url(${profilePictureUrl})`}
          backgroundSize="cover"
          backgroundPosition="center"
          marginTop="25px"
          marginBottom="12px"
        />
        <SrText font="greycliff" fontSize="16px" weight="800">
          {name}
        </SrText>
        <SrText font="greycliff" fontSize="12px" weight="600">
          {position}
        </SrText>
        <SrText font="greycliff" fontSize="16px" lineHeight="25px" weight="600">
          {email}
        </SrText>
        <SrText font="greycliff" fontSize="16px" lineHeight="25px" weight="600">
          {formatPhoneNumber(phone)}
        </SrText>
        {linkText && linkUrl && (
          <SrLink to={linkUrl} target="_blank">
            <SrText font="greycliff" fontSize="16px" lineHeight="25px" color="blue300" weight="600">
              {linkText}
            </SrText>
          </SrLink>
        )}
      </SrBox>
    </SrCard>
  );
};

export default UPAccountManagerCard;
